import React from 'react';
import createAccessibleOnClick from 'utils/createAccessibleOnClick';

interface Props {
  isPlaying?: boolean;
  onClick?: () => void;
}

/**
 * Component that renders either a play or pause icon depending on the `isPlaying` prop.
 */
const PlayPauseIcon = ({ isPlaying = false, onClick = () => {} }: Props) => (
  <div className="sl-play-pause-container">
    <button
      className="sl-play-pause-button"
      type="button"
      {...(createAccessibleOnClick(onClick) as any)}
      aria-label={isPlaying ? 'Pause Webcam' : 'Play Webcam'}
    >
      <svg
        width="16px"
        height="20px"
        viewBox="0 0 16 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          {isPlaying ? (
            <g
              className="sl-play-pause-button__shape"
              transform="translate(-764.000000, -774.000000)"
              fillRule="nonzero"
            >
              <g transform="translate(764.000000, 774.000000)">
                <rect x="0" y="0" width="5" height="22" rx="1" />
                <rect x="11" y="-1.58095759e-13" width="5" height="22" rx="1" />
              </g>
            </g>
          ) : (
            <polygon className="sl-play-pause-button__shape" points="16 10 0 20 0 0" />
          )}
        </g>
      </svg>
    </button>
  </div>
);

export default PlayPauseIcon;
